export default function OTT(props){
    return(
        <div className="provider" title = {props.title}><img src={props.logo} alt=""/></div>
    )
}